// ALARM_START_TIGER: bring up the Tiger display for one turbine.
//  * Desktop (Tauri): launch a separate display process (alarm_start_tiger command,
//    port of alarm_start_tiger_widget::click_event). That process picks live vs
//    replay itself at startup (use_online_display / tiger_default_live).
//  * Web: open the display in a new browser tab (?live=<config>); the same SPA
//    treats a ?live= tab as the -live user interface (switch shown, tree scoped
//    to the turbine — see viewMode.getLiveModeEnabled/getLiveConfig) and opens it
//    in the configured default mode (live or replay) on load. The webserver can't
//    spawn a second UI process, so a tab is the web equivalent.

function isTauri(): boolean {
  return typeof window !== "undefined" && "__TAURI_INTERNALS__" in window;
}

export async function startTiger(configName: string | null | undefined): Promise<void> {
  if (!configName) return;
  if (isTauri()) {
    const { invoke } = await import("@tauri-apps/api/core");
    await invoke<void>("alarm_start_tiger", { configName });
  } else {
    window.open(`/?live=${encodeURIComponent(configName)}`, "_blank");
  }
}
